import { render } from "./UserApiDevices.vue?vue&type=template&id=4b55bc72&scoped=true"
import script from "./UserApiDevices.vue?vue&type=script&lang=js"
export * from "./UserApiDevices.vue?vue&type=script&lang=js"

import "./UserApiDevices.vue?vue&type=style&index=0&id=4b55bc72&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b55bc72"]])

export default __exports__